import { render, staticRenderFns, recyclableRender, components } from "./my_shop.vue?vue&type=template&id=58a3b510&"
var renderjs
import script from "./my_shop.vue?vue&type=script&lang=js&"
export * from "./my_shop.vue?vue&type=script&lang=js&"
import style0 from "./my_shop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/user/my_shop/my_shop.vue"
export default component.exports